import axios from "axios";

export default {
    namespaced: true,

    state: {
        mapPatterns: [],
    },

    getters: {
        mapPatterns(state) {
            return state.mapAttmapPatternsributes;
        },
    },

    mutations: {
        SET_MAP_PATTERNS(state, mapPatterns) {
            state.mapPatterns = mapPatterns;
        },
    },

    actions: {
        async getMapPatterns({ commit }, id) {
            return await axios.get("/api/get-all-map-patterns", {
                params: { id },
            });
        },
        async saveMapPattern({ commit }, payload) {
            await axios
                .post("/api/create-map-pattern", payload)
                .then((response) => {});
        },
        async getPattern({ commit }, id) {
            return await axios.get("/api/get-map-pattern", {
                params: { id },
            });
        },
        async updateMapPattern({ commit }, payload) {
            await axios
                .post("/api/update-map-pattern", payload)
                .then((response) => {});
        },
        async deleteMapPattern({ commit }, id) {
            await axios
                .post("/api/delete-map-pattern", { id })
                .then((response) => {});
        },
    },
};
